var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.studentSieId)?_c('div',[_c('page-header',{attrs:{"has-return":"","page":{
      icon: 'fas fa-user-edit',
      title: 'Referidos de Evaluación del Estudiante',
      routes: ['Inicio', 'Referidos de Evaluación del Estudiante'],
    }}}),_c('student-referral-evaluations',{attrs:{"student-sie-id":Number(_vm.studentSieId)}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }